import { useState } from "react";
import { Dialog } from "@headlessui/react";
import MapSearchBar from "./MapSearchBar";

const getLabel = function (assessments, filters) {
    try {
        if (!filters || !assessments || assessments.length === 0 || filters.length === 0) {
            return 'All Assessments'
        }

        const matchingAssessments = assessments.filter(assessment => {
            return filters.includes(assessment.id);
        }).map(assessment => assessment.title.rendered);

        return matchingAssessments.join(', ');
    } catch {
        return 'All Assessments'
    }
}

export default function MobileSearch({
    currentMode,
    changeMode,
    defaultSearchTerm,
    onCoordinatesChange,
    assessments,
    filters,
    setFilters,
}) {
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [newFilters, setNewFilters] = useState(filters);

    const label = getLabel(assessments, filters);

    return (
        <div className="search-map__mobile-search">
            <MapSearchBar
                defaultSearchTerm={defaultSearchTerm}
                onCoordinatesChange={onCoordinatesChange}
            />
            <button
                type="button"
                className="search-map__toggle"
                onClick={changeMode}
            >
                change to {currentMode === "controls" ? "map" : "controls"}
            </button>
            <button
                type="button"
                className="search-map__assessments"
                onClick={() => setFiltersOpen(!filtersOpen)}
                dangerouslySetInnerHTML={{ __html: label }}
            />
            <Dialog
                onClose={() => setFiltersOpen(false)}
                open={filtersOpen}
                className="search-map__mobile-filters"
            >
                <Dialog.Panel>
                    <button onClick={() => setFiltersOpen(false)}>x</button>
                    {assessments?.map((assessment) => (
                        <label key={assessment.id}>
                            <input
                                type="checkbox"
                                value={assessment.id}
                                checked={newFilters.includes(assessment.id)}
                                onChange={() =>
                                    newFilters.includes(assessment.id)
                                        ? setNewFilters(
                                            newFilters.filter(
                                                (f) => f !== assessment.id
                                            )
                                        )
                                        : setNewFilters([
                                            ...newFilters,
                                            assessment.id,
                                        ])
                                }
                            />{" "}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: assessment.title?.rendered,
                                }}
                            />
                        </label>
                    ))}
                    <button
                        onClick={() => {
                            setFilters(newFilters);
                            setFiltersOpen(false);
                        }}
                    >
                        Apply
                    </button>
                </Dialog.Panel>
            </Dialog>
        </div>
    );
}
